import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { acBilet } from '../actions/acBilet';
class Miza extends React.Component {

    // constructor() {
    //     super();
    //     this.state = { nrTabs: 2 };
    // }

    updateMiza(val, e) {
        // if (val.valid === true) {
        var miza = e.target.value
        // parseInt(e.target.value, 10);

        if ((isNaN(miza) === true) && (miza !== '')) {
            miza = 0;
        }
        if (miza >= this.props.defaultVal.max_bet) {
            miza = this.props.defaultVal.max_bet;
        }
        if (miza < 0) {
            miza = 0;
        }
        var values = {
            position: val.position,
            miza: miza
        }
        this.props.acBilet(['biletMiza', values])
        // }
    }
    maxMiza(val) {
        if (val.valid === true) {
            var values = {
                position: val.position,
                miza: this.props.defaultVal.max_bet
            }
            this.props.acBilet(['biletMiza', values])
        }
    }
    changeSum(val) {

        var max = this.props.defaultVal.max_bet
        var min_bet = this.props.defaultVal.min_bet
        var min = 0
        var sumTicket = parseFloat(this.props.biletVal.miza)
        if (val === 'up') {
            var newSum = parseFloat(sumTicket) + min_bet

            if (sumTicket >= max) { newSum = max }

            var values = {
                position: this.props.biletVal.position,
                miza: Math.round(newSum * 100.0) / 100.0
            }
            this.props.acBilet(['biletMiza', values])
        }

        if (val === 'down') {
            newSum = parseFloat(sumTicket) - min_bet

            if (sumTicket <= min) { newSum = min }

            values = {
                position: this.props.biletVal.position,
                miza: Math.round(newSum * 100.0) / 100.0
            }
            this.props.acBilet(['biletMiza', values])
        }
    }
    checkMinSum() {
        if (this.props.biletVal.miza < this.props.defaultVal.min_bet) {
            return ''
        } else {
            return 'op0'
        }
    }
    onBlur(event) {
        if (event.target.value === '') {
            event.target.value = 0;
        }
    }
    clearOnFocus(event) {
        if (parseInt(event.target.value, 10) === 0) {
            event.target.value = '';
        }
    }
    mizaToFixed(val) {
        if (val && val.length > 0) {
            let punct = val.endsWith('.')
            if (punct === true) {
                return val
            } else {
                return Math.round(val * 100) / 100
            }
        } else {
            return val
        }
    }
    render() {
        let win = this.props.biletVal.castigEv * (1 + this.props.biletVal.future)
        return (
            <div className="bilet-curent">
                <div className={"val-error " + this.checkMinSum()}>{this.props.multiLang.mizaInfo.txt + ' ' + this.props.defaultVal.min_bet + ' ' + this.props.defaultVal.currency}</div>
                <div className="con-con-miza">
                    <span>{this.props.multiLang.stake.txt}</span>
                    <span>
                        <div className="con-miza">
                            <div className="minus" onClick={this.changeSum.bind(this, 'down')}><div>-</div></div>
                            <input className="cash-in"
                                type="text"
                                onFocus={this.clearOnFocus.bind(this)}
                                onBlur={this.onBlur.bind(this)}
                                value={this.mizaToFixed(this.props.biletVal.miza)}
                                onChange={this.updateMiza.bind(this, this.props.biletVal)}
                            />
                            <div className="plus" onClick={this.changeSum.bind(this, 'up')}>
                                <div>+</div>
                            </div>
                        </div>
                    </span>
                </div>
                <div className="cota">
                    <span>{this.props.multiLang.odd.txt}<img id="info-img" src="img/icon/info.svg" alt="" title={this.props.multiLang.oddInfo.txt} /></span>
                    <span className="cotaTot-value">{this.props.biletVal.cotaTot}</span>
                </div>
                <div className="castig">
                    <span>{this.props.multiLang.castig.txt}</span>
                    <span>{win.toFixed(2) + ' ' + this.props.defaultVal.currency}</span>
                </div>

            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        defaultVal: state.defaultVal,
        multiLang: state.multiLang,
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acBilet: acBilet
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Miza);
